export enum CanvasAgentResponseApiModelSchedulingTypeEnum {
    PUBLISH_NOW = 'Publish Now',
    PUBLISH_LATER = 'Publish Later',
    RECURRING = 'Recurring'
}
